
// Define acknowledgment patterns
export const ACKNOWLEDGMENT_PATTERNS = [
  /^perfect!?$/i,
  /^👍$/,
  /^thanks!?$/i,
  /^thank you!?$/i,
  /^great!?$/i,
  /^awesome!?$/i,
  /^ok!?$/i,
  /^yes!?$/i,
  /^good!?$/i,
];

// Define interface for acknowledgment detection result
export interface AcknowledgmentResult {
  isAcknowledgment: boolean;
  type: 'confirmation' | 'gratitude' | 'approval' | null;
}

export const detectAcknowledgment = (content: string): AcknowledgmentResult => {
  const normalizedContent = content.trim().toLowerCase();
  
  if (ACKNOWLEDGMENT_PATTERNS.some(pattern => pattern.test(normalizedContent))) {
    // Determine acknowledgment type
    if (normalizedContent.match(/^(perfect|great|awesome|good)/i)) {
      return { isAcknowledgment: true, type: 'approval' };
    } else if (normalizedContent.match(/^(thanks|thank)/i)) {
      return { isAcknowledgment: true, type: 'gratitude' };
    } else {
      return { isAcknowledgment: true, type: 'confirmation' };
    }
  }
  
  return { isAcknowledgment: false, type: null };
};
